export default function IconLealtad() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_31_17154)">
        <g clipPath="url(#clip1_31_17154)">
          <path
            d="M10.3947 16.5753C10.0736 16.5753 9.79269 16.4549 9.55188 16.2141L5.97998 12.6422C5.49837 12.1606 5.49837 11.398 5.97998 10.9566C6.46158 10.475 7.22413 10.475 7.6656 10.9566L10.3947 13.6857L16.2944 7.78601C16.776 7.3044 17.5385 7.3044 17.98 7.78601C18.4616 8.26761 18.4616 9.03016 17.98 9.47163L11.2375 16.2542C11.0368 16.4549 10.7158 16.5753 10.3947 16.5753Z"
            fill="#05C0C7" />
          <path
            d="M12 24C5.37793 24 0 18.6221 0 12C0 5.37793 5.37793 0 12 0C18.6221 0 24 5.37793 24 12C24 18.6221 18.6221 24 12 24ZM12 2.40803C6.70234 2.40803 2.40803 6.70234 2.40803 12C2.40803 17.2977 6.70234 21.592 12 21.592C17.2977 21.592 21.592 17.2977 21.592 12C21.592 6.70234 17.2977 2.40803 12 2.40803Z"
            fill="#088387" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_31_17154">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_31_17154">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}